// @flow

const DateEntity = (dateData) => {
	if (!dateData) return null

	return dateData !== 'false' ? +dateData : null
}

export default DateEntity
